import { load } from "../../events/load";

const initAboutMeReadMore = () => {
  const readMoreButton = document.querySelector(".about-me__read-more");
  const hiddenText = document.querySelector(".about-me__low");

  if (!readMoreButton || !hiddenText) return;

  readMoreButton.addEventListener("click", () => {
    hiddenText.classList.toggle("is-visible");
    readMoreButton.classList.toggle("is-expanded");
    const textElement = readMoreButton.querySelector(".btn__text");

    if (hiddenText.classList.contains("is-visible")) {
      if (textElement) textElement.textContent = "згорнути";
    } else {
      if (textElement) textElement.textContent = "читати більше";
    }
  });
};

load(initAboutMeReadMore);

